import { apiHttp } from '../axiosApi'
import {
  userLogin,
  userGoogleLogin,
  userAppleLogin,
  userProfile,
  userUpdate,
  userUpdatePassword,
  userForgotPassword,
  userDelete,
  userAvatar,
  userBackground,
  userRoles
} from '../config/apiRoute'

const VITE_API_APPLICATION = `${import.meta.env.VITE_API_APPLICATION}`

export const loginApi = ({ email, password }) => {
  return apiHttp(
    'POST',
    `${userLogin}`,
    { email, password, application: VITE_API_APPLICATION },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Basic ${btoa(`${email}:${password}:${VITE_API_APPLICATION}`)}`
      }
    }
  )
}

export const googleLoginApi = (code) => {
  return apiHttp(
    'POST',
    `${userGoogleLogin}`,
    { ...code, application: VITE_API_APPLICATION },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Basic ${btoa(`${VITE_API_APPLICATION}`)}`
      }
    }
  )
}

export const appleLoginApi = (code) => {
  return apiHttp(
    'POST',
    `${userAppleLogin}`,
    { ...code, application: VITE_API_APPLICATION },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Basic ${btoa(`${VITE_API_APPLICATION}`)}`
      }
    }
  )
}

export const getUserProfile = () => apiHttp('GET', `${userProfile}`)
export const getUserRoles = () => apiHttp('GET', `${userRoles}`, {}, {}, false)
export const putUserProfile = (body) => apiHttp('PUT', `${userUpdate}`, body)
export const putUserPassword = () => apiHttp('PUT', `${userUpdatePassword}`)
export const deleteUserProfile = () => apiHttp('DELETE', `${userDelete}`)
export const putUserForgotPassword = (params) =>
  apiHttp(
    'PUT',
    `${userForgotPassword}`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      params: params
    }
  )
export const postUserAvatar = (body) => {
  try {
    const accessToken = localStorage.getItem('accessToken')
    return apiHttp('POST', `${userAvatar}`, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    })
  } catch (error) {
    return error
  }
}
export const postUserBackground = (body) => {
  try {
    const accessToken = localStorage.getItem('accessToken')
    return apiHttp('POST', `${userBackground}`, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    })
  } catch (error) {
    return error
  }
}
